import { ScrollPosition } from '../../types/enumScrollPosition';

export const handleScroll = (event: React.UIEvent<HTMLDivElement>, setScrollPosition: React.Dispatch<React.SetStateAction<ScrollPosition>>) => {
    const target = event.target as HTMLDivElement;
    const { scrollTop, scrollHeight, clientHeight } = target;

    if (scrollTop === 0) {
        setScrollPosition(ScrollPosition.TOP);
    } else if (scrollTop + clientHeight >= scrollHeight * 0.95) {
        setScrollPosition(ScrollPosition.BOTTOM);
    } else {
        setScrollPosition(ScrollPosition.MIDDLE);
    }
};
